<div class="delivery-options">
	<!--  STEP HEADER  -->

	<cng-step-header
		[current_step_key]="current_step_key"
		[location]="'engage_configure'"
		(jump)="jumpTo($event)"
	></cng-step-header>

	<!--  END STEP HEADER  -->

	<div *ngIf="!delivery_options.locked" class="container">
		<!--  HEADING  -->

		<div class="heading">
			<ui-concierge
				*ngIf="delivery_options.collection.available && delivery_options.delivery.available"
				data-element-view="concierge__engage_configure_delivery_options_step__[How would you like to arrange handover?]"
			>
				<h1>How would you like to arrange handover?</h1>
				<p>
					We provide options for collection or delivery of your new vehicle. Please choose your preference
					below.
				</p>
			</ui-concierge>

			<ui-concierge
				*ngIf="delivery_options.collection.available && !delivery_options.delivery.available"
				data-element-view="concierge__engage_configure_delivery_options_step__[Would you like to arrange collection?]"
			>
				<h1>Would you like to arrange collection?</h1>
				<p>Please make an appointment with our friendly staff to visit us to collect your new vehicle.</p>
			</ui-concierge>

			<ui-concierge
				*ngIf="!delivery_options.collection.available && delivery_options.delivery.available"
				data-element-view="concierge__engage_configure_delivery_options_step__[Would you like to arrange delivery?]"
			>
				<h1>Would you like to arrange delivery?</h1>
				<p>
					We're able to provide home delivery of your new vehicle. Please enter your address below and one of
					our friendly staff members will be in touch.
				</p>
			</ui-concierge>
		</div>

		<!--  END HEADING  -->

		<div
			*ngIf="delivery_options.collection.available && delivery_options.delivery.available"
			class="container button-delivery-options-container"
		>
			<a
				class="button"
				[ngClass]="handover_method === 'collection' ? 'primary-button' : 'minor-button'"
				data-element-click="tab__engage_configure_delivery_options__[Click & Collect]"
				(click)="onHandoverMethodToggle('collection')"
			>
				Click &amp; Collect
			</a>
			<a
				class="button"
				[ngClass]="handover_method === 'delivery' ? 'primary-button' : 'minor-button'"
				data-element-click="tab__engage_configure_delivery_options__[Home Delivery]"
				(click)="onHandoverMethodToggle('delivery')"
			>
				Home Delivery
			</a>
		</div>

		<div
			class="accordion checklist-accordion"
			[class.has-tabs]="delivery_options.collection.available && delivery_options.delivery.available"
		>
			<div *ngIf="handover_method === 'collection'" class="accordion-item active">
				<div class="accordion-item-content">
					<cng-configure-collection-form></cng-configure-collection-form>
				</div>
			</div>
			<div *ngIf="handover_method === 'delivery'" class="accordion-item active">
				<div class="accordion-item-content">
					<cng-configure-delivery-form></cng-configure-delivery-form>
					<div class="highlighted-notice plain">
						<i class="fas fa-info-circle pri"></i>
						<div>
							<p>
								<strong>Home Delivery Charges.</strong>
							</p>
							<p>
								Depending on your location, there may be a small charge to facilitate home delivery. One our friendly staff
								members will discuss this with you when your appointment is confirmed. If you would like to find out more,
								please get in touch.
							</p>
							<a
								class="button small-button primary-button visible-xxs-inline-block visible-xs-inline-block"
								data-element-click="button__engage_configure_delivery_options[delivery_form]__primary-button[Contact Us]"
								(click)="onContactUs()"
							>
								Contact Us
							</a>
						</div>
						<a
						class="button small-button primary-button hidden-xxs hidden-xs"
						data-element-click="button__engage_configure_delivery_options[delivery_form]__primary-button[Contact Us]"
						(click)="onContactUs()"
					>
						Contact Us
					</a>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="hasFollowingSteps()" class="container button-container">
			<a
				class="button block-button minor-button button-with-icon-right"
				data-element-click="button__engage_configure_delivery_options__minor-button[Skip This Step]"
				(click)="jumpTo('payment')"
			>
				<span class="text">Skip This Step</span>
				<i class="icon-arrow-right"></i>
			</a>
		</div>
	</div>

	<!--  COLLECTION PENDING  -->

	<div
		*ngIf="
			delivery_options.locked &&
			delivery_options.handover.date &&
			delivery_options.handover.type === 1 &&
			!delivery_options.handover.confirmed
		"
		class="container"
	>
		<div class="heading">
			<ui-concierge
				data-element-view="concierge__engage_configure_delivery_options_step[collection]__[Your collection appointment has been requested!]"
			>
				<h1>Your collection appointment has been requested!</h1>
			</ui-concierge>
		</div>
		<div class="inner-panel delivery-details">
			<div class="inner-panel-section alt status-container">
				<ul class="labelled-list">
					<li class="headline-value">
						<div class="label">Appointment Status:</div>
						<div class="value">
							<i class="fas fa-clock pri"></i>
							Pending
						</div>
					</li>
				</ul>
			</div>
			<div class="inner-panel-separator"></div>
			<div class="row">
				<div class="col-xxs-30 col-sm-15">
					<div class="inner-panel-section address-container">
						<h4 class="label">Collection Address:</h4>
						<p [innerHtml]="collection_address || dealer.address"></p>
					</div>
				</div>
				<div class="col-xxs-30 col-sm-15">
					<div class="inner-panel-section date-container">
						<h4 class="label">Collection Date:</h4>
						<p>
							{{ delivery_options.handover.date | date: 'EEEE dd/MM/yyyy' }} -
							{{ (delivery_options.handover.date | date: 'H') === '10' ? 'Morning' : 'Afternoon' }}
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="highlighted-notice">
			<i class="fas fa-exclamation-circle neg"></i>
			<div>
				<p>
					<strong>
						Your collection appointment is pending. Please do not travel to our showroom without a confirmed
						appointment.
					</strong>
				</p>
				<p>
					One of our friendly staff members will be in touch to confirm your appointment. Unfortunately we
					will not be able to hand the vehicle over without a pre-arranged appointment.
				</p>
				<a
					class="button small-button primary-button visible-xxs-inline-block visible-xs-inline-block"
					data-element-click="button__engage_configure_delivery_options[collection_pending]__primary-button[Contact Us]"
					(click)="onContactUs()"
				>
					Contact Us
				</a>
			</div>
			<a
				class="button small-button primary-button hidden-xxs hidden-xs"
				data-element-click="button__engage_configure_delivery_options[collection_pending]__primary-button[Contact Us]"
				(click)="onContactUs()"
			>
				Contact Us
			</a>
		</div>
	</div>

	<!-- END COLLECTION PENDING  -->

	<!--  COLLECTION CONFIRMED  -->

	<div
		*ngIf="
			delivery_options.locked &&
			delivery_options.handover.date &&
			delivery_options.handover.type === 1 &&
			delivery_options.handover.confirmed
		"
		class="container"
	>
		<div class="heading">
			<ui-concierge
				data-element-view="concierge__engage_configure_delivery_options_step[collection]__[Your collection appointment is confirmed!]"
			>
				<h1>Your collection appointment is confirmed!</h1>
			</ui-concierge>
		</div>
		<div class="inner-panel delivery-details">
			<div class="inner-panel-section alt status-container">
				<ul class="labelled-list">
					<li class="headline-value">
						<div class="label">Appointment Status:</div>
						<div class="value">
							<i class="fas fa-check-circle pos"></i>
							Confirmed
						</div>
					</li>
				</ul>
			</div>
			<div class="inner-panel-separator"></div>
			<div class="row">
				<div class="col-xxs-30 col-sm-15">
					<div class="inner-panel-section address-container">
						<h4 class="label">Collection Address:</h4>
						<p [innerHtml]="collection_address || dealer.address"></p>
					</div>
				</div>
				<div class="col-xxs-30 col-sm-15">
					<div class="inner-panel-section date-container">
						<h4 class="label">Collection Date:</h4>
						<p>
							{{ delivery_options.handover.date | date: 'EEEE dd/MM/yyyy' }} at
							{{ delivery_options.handover.date | date: 'HH:mm' }}
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="highlighted-notice plain">
			<i class="fas fa-info-circle pri"></i>
			<div>
				<p>
					<strong>Your collection appointment is confirmed.</strong>
				</p>
				<p>
					We look forward to welcoming you into our showroom to collect your new vehicle! If for any reason
					you cannot make your arranged appointment, please let us know and we will be happy to rearrange to a
					more suitable time.
				</p>
				<a
					class="button small-button primary-button visible-xxs-inline-block visible-xs-inline-block"
					data-element-click="button__engage_configure_delivery_options[collection_confirmed]__primary-button[Contact Us]"
					(click)="onContactUs()"
				>
					Contact Us
				</a>
			</div>
			<a
				class="button small-button primary-button hidden-xxs hidden-xs"
				data-element-click="button__engage_configure_delivery_options[collection_confirmed]__primary-button[Contact Us]"
				(click)="onContactUs()"
			>
				Contact Us
			</a>
		</div>
	</div>

	<!-- END COLLECTION CONFIRMED  -->

	<!--  DELIVERY PENDING  -->

	<div
		*ngIf="
			delivery_options.locked &&
			delivery_options.handover.date &&
			delivery_options.handover.type === 2 &&
			!delivery_options.handover.confirmed &&
			delivery_options.delivery.address.postcode
		"
		class="container"
	>
		<div class="heading">
			<ui-concierge
				data-element-view="concierge__engage_configure_delivery_options_step[delivery]__[Your delivery has been requested!]"
			>
				<h1>Your delivery has been requested!</h1>
			</ui-concierge>
		</div>
		<div class="inner-panel delivery-details">
			<div class="inner-panel-section alt status-container">
				<ul class="labelled-list">
					<li class="headline-value">
						<div class="label">Delivery Status:</div>
						<div class="value">
							<i class="fas fa-clock pri"></i>
							Pending
						</div>
					</li>
				</ul>
			</div>
			<div class="inner-panel-separator"></div>
			<div class="row">
				<div class="col-xxs-30 col-sm-15">
					<div class="inner-panel-section address-container">
						<h4 class="label">Delivery Address:</h4>
						<p [innerHtml]="delivery_address"></p>
					</div>
				</div>
				<div class="col-xxs-30 col-sm-15">
					<div class="inner-panel-section date-container">
						<h4 class="label">Delivery Date:</h4>
						<p>
							{{ delivery_options.handover.date | date: 'EEEE dd/MM/yyyy' }} -
							{{ (delivery_options.handover.date | date: 'H') === '10' ? 'Morning' : 'Afternoon' }}
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="highlighted-notice plain">
			<i class="fas fa-info-circle pri"></i>
			<div>
				<p><strong>What happens next?</strong></p>
				<p>
					One of our friendly staff members will contact you to discuss your delivery. If you have any
					questions please feel free to get in touch!
				</p>
				<a
					class="button small-button primary-button visible-xxs-inline-block visible-xs-inline-block"
					data-element-click="button__engage_configure_delivery_options[delivery_pending]__primary-button[Contact Us]"
					(click)="onContactUs()"
				>
					Contact Us
				</a>
			</div>
			<a
				class="button small-button primary-button hidden-xxs hidden-xs"
				data-element-click="button__engage_configure_delivery_options[delivery_pending]__primary-button[Contact Us]"
				(click)="onContactUs()"
			>
				Contact Us
			</a>
		</div>
	</div>

	<!-- END DELIVERY PENDING  -->

	<!--  DELIVERY CONFIRMED  -->

	<div
		*ngIf="
			delivery_options.locked &&
			delivery_options.handover.date &&
			delivery_options.handover.type === 2 &&
			delivery_options.handover.confirmed &&
			delivery_options.delivery.address.postcode
		"
		class="container"
	>
		<div class="heading">
			<ui-concierge>
				<h1>Your delivery appointment is confirmed!</h1>
			</ui-concierge>
		</div>
		<div class="inner-panel delivery-details">
			<div class="inner-panel-section alt status-container">
				<ul class="labelled-list">
					<li class="headline-value">
						<div class="label">Appointment Status:</div>
						<div class="value">
							<i class="fas fa-check-circle pos"></i>
							Confirmed
						</div>
					</li>
				</ul>
			</div>
			<div class="inner-panel-separator"></div>
			<div class="row">
				<div class="col-xxs-30 col-sm-15">
					<div class="inner-panel-section address-container">
						<h4 class="label">Delivery Address:</h4>
						<p [innerHtml]="delivery_address"></p>
					</div>
				</div>
				<div class="col-xxs-30 col-sm-15">
					<div class="inner-panel-section date-container">
						<h4 class="label">Delivery Date:</h4>
						<p>
							{{ delivery_options.handover.date | date: 'EEEE dd/MM/yyyy' }} at
							{{ delivery_options.handover.date | date: 'HH:mm' }}
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="highlighted-notice plain">
			<i class="fas fa-info-circle pri"></i>
			<div>
				<p>
					<strong>Your delivery is confirmed.</strong>
				</p>
				<p>
					One of our friendly staff members will be in touch on the day to confirm your delivery appointment.
					Please let us know as soon as possible if you need to make any changes to your appointment date or
					time.
				</p>
				<a
					class="button small-button primary-button visible-xxs-inline-block visible-xs-inline-block"
					(click)="onContactUs()"
				>
					Contact Us
				</a>
			</div>
			<a class="button small-button primary-button hidden-xxs hidden-xs" (click)="onContactUs()">Contact Us</a>
		</div>
	</div>

	<!-- END DELIVERY CONFIRMED  -->

	<!--  STEP BAR  -->

	<cng-step-bar
		[current_step_key]="current_step_key"
		[show_next]="hasFollowingSteps()"
		(jump)="jumpTo($event)"
	></cng-step-bar>

	<!--  END STEP BAR  -->

	<!--  SCROLL FADES  -->

	<div class="scroll-fade top"></div>
	<div class="scroll-fade bottom"></div>

	<!-- END SCROLL FADES  -->
</div>
